import React, { useEffect, useState, useRef } from 'react';
import DataTable from 'datatables.net-react';
import DT from 'datatables.net-dt';
import './css/TransactionHistory.css'; // Common styles for info blocks
import { Loading } from './loading.js';
import { Turl } from './tUrl.js'
import { t } from 'ttag';

DataTable.use(DT);
// Telegram Mini Apps API (доступен глобально в Mini Apps)
const tg = window.Telegram ? window.Telegram.WebApp : null;

function TransactionHistory() {

    const [mData, setmData] = useState(null);
    const hasFetchedData = useRef(false); // Ref для отслеживания первого вызова

    useEffect(() => {
        const getData = async () => {
            hasFetchedData.current = true;

            try {
                const _userData = tg ? tg.initData : null;
                let userData = { initData: _userData }


                if (userData) {
                    const response = await fetch(Turl + '/api/transactions', {
                        method: 'POST',
                        headers: { 'Content-Type': 'application/json' },
                        body: JSON.stringify(userData)
                    });

                    if (!response.ok) {
                        throw new Error(`HTTP error! Status: ${response.status}`);
                    }
                    let rd = await response.json();
                    setmData(rd)

                } else {
                    // Handle case where user data is not available (e.g., show error)
                    console.warn("Telegram user data not available.");
                    // You might want to display an error message to the user here.
                }

            } catch (error) {
                console.error('Authentication error:', error);
            }
        };

        if (!mData && !hasFetchedData.current) {
            getData();
        }
    }, [mData]);

    if (!mData)
        return <Loading />;
    hasFetchedData.current = false;

    return (
        <div style={{ width: "100%" }}>
            <div className="balance-block">
                <div className="balance-aw">
                    <div className="balance-amount">{mData.totalEarned.toFixed(2)} USDT</div>
                    <span className="label">{t`Total earned`}</span>
                </div>
                <div className="balance-details">
                    <div className="balance-item">
                        <span className="amount">{mData.partnerBonus.toFixed(2)} USDT</span>
                        <span className="label">{t`Affiliate bonus`}</span>
                    </div>
                    <div className="balance-item">
                        <span className="amount">{mData.equityPool.toFixed(2)} USDT</span>
                        <span className="label">{t`Equity pool`}</span>
                    </div>
                    <div className="balance-item">
                        <span className="amount">{mData.cardBonus.toFixed(2)} USDT</span>
                        <span className="label">{t`Card affiliate`}</span>
                    </div>
                    <div className="balance-item">
                        <span className="amount soon">{mData.dividends === 0 ? t`SOON` : mData.dividends.toFixed(2) + " USDT"}</span>
                        <span className="label">{t`Dividends`}</span>
                    </div>
                </div>
            </div>
            <div className="THDataTable">
                <div className="table-responsive ">
                    <DataTable
                        data={mData.transactions}
                        className="display dark cell-border compact stripe"
                        options={{
                            searching: false,
                            autoWidth: true,
                            layout: { topStart: null },

                        }}
                        columns={[
                            { data: 'Details' },
                            { data: 'dt' },
                            { data: 'amount' },
                        ]}
                    >
                        <thead>
                            <tr>
                                <th>{t`Details`}</th>
                                <th style={{ width: "30%" }}>{t`Date`}</th>
                                <th style={{ width: "20%" }}>{t`Amount`}</th>
                            </tr>
                        </thead>
                    </DataTable>
                </div>
            </div>
        </div>
    );
}

export { TransactionHistory };